import { z } from 'zod';

import { s } from 'utilities/strings';

export const ClientSchema = z.object({
  acronym: z.string().optional(),
  backgroundColor: z.string().optional(),
  color: z.string().optional(),
  id: z.union([z.string(), z.number()]).transform((value) => `${value}`),
  isInactive: z.boolean().optional(),
  name: z.string({
    invalid_type_error: s(['Site.Pages.AudienceBuilder.Save.Validation.Client.Required']),
    required_error: s('Site.Pages.AudienceBuilder.Save.Validation.Client.Required'),
  }),
});

export const ClientSchemaOptional = ClientSchema.extend({
  id: z
    .union([z.string(), z.number()])
    .transform((value) => `${value}`)
    .optional(),
  name: z.string().optional(),
});

export type IClient = z.infer<typeof ClientSchema>;
